import React from "react";


import {
    PageContainerComponent,
    SectionContainerComponent
} from "@Components/Sections";

import {
    SupportSectionComponent
} from "@Parts/@Support";

import {
    HeadSectionComponent
} from "@Parts/Sections";


import {
    InformativeCardComponent
} from "@Components/Elements";


import {
    LegalElementsListElementType
} from "@Pages/@LegalPages/@Parts/LegalsElementsList/LegalElement";


import headSectionImage from "./@Images/headSectionImage.svg";


import iconMessage from "@Icons/SVG/icon-message.svg";


import "./index.scss";


const LegalElementsList:LegalElementsListElementType[] = [
    {
        elementOrderNr: 0,
        elementTitle: 'Purpose / Objective',
        elementContent: `
            <p>SignalFire (“the company”) is committed to providing a work environment that is free of unlawful sexual harassment. In furtherance of this commitment, the company strictly prohibits all forms of unlawful harassment, which includes harassment on the basis of sex (including pregnancy, breastfeeding and related medical conditions), gender identity and expression, sexual orientation, or any other category protected by applicable local, state or federal laws.</p>
        `
    },
    {
        elementOrderNr: 0,
        elementTitle: 'Eligibility',
        elementContent: `
            <p>This policy prohibits unlawful sexual harassment and applies to all employees of the company, including supervisors and managers. The company prohibits managers, supervisors and employees from sexually harassing co­workers as well as customers, vendors, suppliers, independent contractors and others doing business with the company. In addition, the company prohibits customers, vendors, suppliers, independent contractors and others doing business with the company from sexually harassing the company’s employees.</p>
        `
    },
    {
        elementOrderNr: 0,
        elementTitle: 'Procedures',
        elementContent: `
            <p>Violation of this policy will subject an employee to disciplinary action, up to and including immediate termination. Additionally, under California law, employees may be held personally liable for sexually harassing conduct that violates the California Fair Employment and Housing Act (FEHA).</p>
        `
    },
    {
        elementOrderNr: 0,
        elementTitle: 'Reporting sexual harassment',
        elementContent: `
            <p>If an employee feels that he or she is being sexually harassed in violation of this policy by another employee, supervisor, manager or third party doing business with the company, he or she should immediately contact Chris Farmer, Managing Director, or his/her supervisor. In addition, if an employee observes sexual harassment by another employee, supervisor, manager or nonemployee, the employee should immediately report the incident to the individuals above. Appropriate action will also be taken in response to violation of this policy by any nonemployee.</p>
            <p>Employees’ notification to the company is essential to enforcing this policy. Employees may be assured that they will not be penalized in any way for reporting a sexual harassment problem. It is unlawful for an employer to retaliate against employees who oppose the practices prohibited by the FEHA, or to file complaints, or otherwise to participate in an investigation, proceeding or hearing conducted by the California Department of Fair Employment and Housing (DFEH) or the Fair Employment and Housing Council (FEHC). Similarly, the company prohibits employees from hindering the company’s internal investigations or the company’s internal complaint procedure.</p>   
            <p>All complaints of unlawful sexual harassment that are reported to management or to the persons identified above will be investigated as promptly as possible, and corrective action will be taken where warranted. All complaints of unlawful sexual harassment that are reported to management or to the persons identified above will be treated with as much confidentiality as possible, consistent with the need to conduct an adequate investigation. The California DFEH may also investigate and process complaints of sexual harassment. Violators are subject to penalties and remedial measures that may include sanctions, fines, injunctions, reinstatement, back pay and damages. The DFEH toll­free number is (800) 884­-1684.</p>
        `
    },
    {
        elementOrderNr: 0,
        elementTitle: 'Examples of prohibited sexual harassment',
        elementContent: `
            <p>Sexual harassment includes a broad spectrum of conduct, including harassment based on gender, transgender and sexual orientation (meaning one’s heterosexuality, homosexuality or bisexuality). Examples of unlawful and unacceptable behavior include:</p>
            <ol>
                <li>Unwanted sexual advances.</li>
                <li>Offering an employment benefit (such as a raise, promotion or assistance with one’s career) in exchange for sexual favors, or threatening an employment detriment (such as termination, demotion or disciplinary action) for an employee’s failure to engage in sexual activity.</li>
                <li>Visual conduct, such as leering, making sexual gestures, or displaying sexually suggestive objects, pictures, cartoons or posters.</li>
                <li>Verbal sexual advances, propositions, requests or comments.</li>
                <li>Sending sexually related text messages, videos or messages via social media.</li>
                <li>Verbal abuse of a sexual nature, graphic verbal commentaries about an individual’s body, sexually degrading words used to describe an individual, or suggestive or obscene letters, notes or invitations.</li>
                <li>Physical conduct, such as touching, assault, or impeding or blocking movement.</li>
                <li>Physical or verbal abuse concerning an individual’s actual sex or the perception of the individual’s sex.</li>
                <li>Verbal abuse concerning a person’s characteristics such as vocal pitch, facial hair or the size or shape of a person’s body, including remarks that a male is too feminine or a woman is too masculine.</li>
            </ol>
            <p>Sexual harassment of the company’s customers, clients, vendors, suppliers, independent contractors or employees of the company’s customers, clients, vendors, suppliers or independent contractors by the company’s employees is also strictly prohibited. Such sexual harassment includes the types of behavior specified in this policy, including sexual advances, verbal or physical conduct of a sexual nature, sexual comments and gender ­based insults. Any such sexual harassment will subject an employee to disciplinary action, up to and including termination. Employees who have any questions about what constitutes sexually harassing behavior should contact their supervisor.</p>
        `
    },
    {
        elementOrderNr: 0,
        elementTitle: 'Retaliation prohibited',
        elementContent: `
            <p>The company prohibits retaliation against those who report, oppose or participate in an investigation of alleged violations of this policy. Participating in an investigation of alleged wrongdoing in the workplace includes:</p>
            <ol>
                <li>Filing a complaint with a federal or state enforcement or administrative agency.</li>
                <li>Participating in or cooperating with a federal or state enforcement agency that is conducting an investigation of the company regarding alleged unlawful activity.</li>
                <li>Testifying as a party, witness or accused regarding alleged unlawful activity.</li>
                <li>Associating with another employee who is engaged in any of these activities.</li>
                <li>Making or filing an internal complaint with the company regarding alleged unlawful activity.</li>
                <li>Providing informal notice to the company regarding alleged unlawful activity.</li>
            </ol>
            <p>The company strictly prohibits any adverse action or retaliation against an employee for participating in an investigation of alleged violation of this policy. If an employee feels that he or she is being retaliated against, he or she should immediately contact Chris Farmer, Managing Director, or his/her supervisor. In addition, if an employee observes retaliation by another employee, supervisor, manager or nonemployee, he or she should immediately report the incident to the individuals above.</p>
            <p>Any employee determined to be responsible for violating this policy will be subject to appropriate disciplinary action, up to and including termination. Moreover, any employee, supervisor or manager who condones or ignores potential violations of this policy will be subject to appropriate disciplinary action, up to and including termination.</p>
        `
    },
    {
        elementOrderNr: 0,
        elementTitle: 'SignalFire Equal Employment Opportunity Policy',
        elementContent: `
            <p>SignalFire provides equal employment opportunities (EEO) to all employees and applicants for employment without regard to race, color, religion, sex, national origin, age, disability or genetics. In addition to federal law requirements, SignalFire complies with applicable state and local laws governing nondiscrimination in employment in every location in which the company has facilities. This policy applies to all terms and conditions of employment, including recruiting, hiring, placement, promotion, termination, layoff, recall, transfer, leaves of absence, compensation and training. SignalFire expressly prohibits any form of workplace harassment based on race, color, religion, gender, sexual orientation, gender identity or expression, national origin, age, genetic information, disability, or veteran status. Improper interference with the ability of SignalFire’s employees to perform their job duties may result in discipline up to and including discharge.</p>
        `
    },
];


export const AntiHarassmentPage:React.FC = () => {

    const ElementsList = LegalElementsList.map((Element, i) =>
        <InformativeCardComponent
            key={i}
            cardDecoration={{ decorationType: 'icon', decorationSource: iconMessage }}
            cardTitle={Element.elementTitle}
            cardDescription={Element.elementContent}
        />
    );

    return (
        <PageContainerComponent pageType={'anti-harassment-page'}>

            <HeadSectionComponent
                pageName={'anti-harassment'}
                sectionHeaderText={'Anti-Harassment and Discrimination'}
                sectionImage={headSectionImage}
            />

            <SectionContainerComponent
                id={'anti-harassment-page__legals-elements-list-section'}
                sectionType={'main'}
            >
                {ElementsList}
            </SectionContainerComponent>

            <SupportSectionComponent />

        </PageContainerComponent>
    );

};


export default AntiHarassmentPage;
